import divImg from '../assets/Img_card_REITs.jpg';
import passImg from '../assets/Img_card_PP.jpg';
import growImg from '../assets/Img_card_1031.jpg';

export default {
  hero: {
    header: 'Invest with new levels of access and confidence ',
    subheader: 'investment options expertly vetted and tailored to you',
  },
  tools: [
    {
      image: divImg,
      title: 'REITS',
      body: 'Invest in a growing portfolio of diverse commercial real estate properties through one of our public, non-traded REITs. Our REITs are designed for income and growth and offer retirement investing choices.',
      section: 'reits',
    },
    {
      image: passImg,
      title: 'INDIVIDUAL PROPERTIES',
      body: 'Qualified investors may invest in single properties or "Private Placements" which are structured as an LLC and designed to meet specific objectives.',
      section: 'pp',
    },
    {
      image: growImg,
      title: '1031 EXCHANGES',
      body: 'For investors seeking capital gains deferment from the sale of an existing property, we can offer 1031 eligible Private Placement investments.',
      section: 'exchange',
    },
  ],
  overview: {
    title: 'A Range of Investing Benefits',
    subtitle: 'Commercial real estate investing offers many possibilities accross various property types. At RealtyMogul, we scrutinize all the options available to find what we believe are the best. The investment products we have created for our members offer distinct benefits and include “REITs”, individual properties, and 1031 Exchanges.',
  },
  meet: {
    title: 'Meet Our REITs',
    body: 'MogulREIT I is focused on providing monthly income to investors through debt and equity investments in a diversified pool of commercial real estate property types, while MogulREIT II focuses on providing investors with the opportunity for capital appreciation by investing in value-add multifamily properties with both preferred and joint-venture equity.',
    bottom: 'Our REITs give you the option of investing using a retirement account',
  },
  reits: [],
};
